import React, { useState } from 'react';
import { Button, Stack, Typography, Tooltip, Badge } from '@mui/material';
import {
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
} from '@mui/x-data-grid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SettingsIcon from '@mui/icons-material/Settings';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMaintenance } from '../../../../actions/rigs';
import RIG_TYPES from './rigTypes';

function NodeGridToolbar({ region, disabled, service, type, selected = [] }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rigs = useSelector((state) => state.rigs);

  const [toggling, setToggling] = useState(false);

  const handleToggleMaintenance = async () => {
    if (!selected || selected.length === 0) {
      return;
    }

    setToggling(true);
    try {
      await Promise.all(
        selected.map(async (rig_uuid) => {
          const rig = rigs.find((rig) => rig_uuid === rig.rig_uuid);
          if (rig) {
            await dispatch(
              toggleMaintenance(
                region.provider_uuid,
                rig.region_uuid,
                rig.rig_uuid,
              ),
            );
          }
        }),
      );
    } catch (error) {
      // Error is already handled by the action's error handling
      console.error('Error toggling maintenance:', error);
    } finally {
      setToggling(false);
    }
  };

  return (
    <Toolbar
      sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    >
      <Stack direction='row' spacing={1}>
        <Tooltip title={Boolean(disabled) ? disabled : ''}>
          <span>
            <Button
              color='brand'
              variant='outlined'
              disabled={Boolean(disabled)}
              onClick={() =>
                navigate({
                  pathname: `/resources/provider/${region.provider_uuid}/region/${region.region_uuid}/node/new`,
                  search: `?service=${service}&type=${type}`,
                })
              }
            >
              <Stack direction='row' spacing={1} alignItems='center'>
                <AddCircleOutlineIcon />
                <Typography variant='button' display='block' gutterBottom>
                  Add
                </Typography>
              </Stack>
            </Button>
            <Button
              variant='outlined'
              disabled={!selected || selected.length === 0}
              onClick={handleToggleMaintenance}
              loading={toggling}
            >
              <Stack direction='row' spacing={1} alignItems='center'>
                <EngineeringIcon />
                <Typography variant='button' display='block' gutterBottom>
                  Toggle Maintenance
                </Typography>
              </Stack>
            </Button>
            {type === RIG_TYPES.DEVICE ? (
              <Button
                variant='outlined'
                disabled={Boolean(disabled)}
                onClick={() =>
                  navigate({
                    pathname: `/resources/provider/${region.provider_uuid}/region/${region.region_uuid}/device/config`,
                  })
                }
              >
                <Stack direction='row' spacing={1} alignItems='center'>
                  <SettingsIcon />
                  <Typography variant='button' display='block' gutterBottom>
                    Set Config
                  </Typography>
                </Stack>
              </Button>
            ) : (
              <></>
            )}
          </span>
        </Tooltip>
      </Stack>
      <Stack direction='row' spacing={1}>
        <Tooltip title='Columns'>
          <ColumnsPanelTrigger render={<ToolbarButton />}>
            <ViewColumnIcon fontSize='small' color='brandBlack' />
          </ColumnsPanelTrigger>
        </Tooltip>
        <Tooltip title='Filters'>
          <FilterPanelTrigger
            render={(props, state) => (
              <ToolbarButton {...props}>
                <Badge badgeContent={state.filterCount} variant='dot'>
                  <FilterListIcon fontSize='small' color='brandBlack' />
                </Badge>
              </ToolbarButton>
            )}
          />
        </Tooltip>
      </Stack>
    </Toolbar>
  );
}
export default NodeGridToolbar;
